// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"cffae0da","440":"38435260","496":"84c84d9c","511":"25f09948","872":"8a9e95d1"}[chunkId] + ".chunk.js";
};